import Zasilkovna from './zasilkovna';

Zasilkovna.init();
